// extracted by mini-css-extract-plugin
module.exports = {"guide":"Payment_guide__2Riy8","intro":"Payment_intro__2_x1n","intro_1":"Payment_intro_1__8SWC2"};